<div class="mb-3" align="end">
	<button class="mat-custom-button" mat-raised-button color="primary" (click)="openDialog()">
		Dodaj masowe płatności
	</button>
</div>
